import {Component} from '@angular/core';
import {Platform, MenuController, App, Nav, AlertController} from 'ionic-angular';
import {ViewChild} from '@angular/core';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {ServiceProvider} from '../providers/service/service';
import {Storage} from '@ionic/storage';
import {ToastController} from 'ionic-angular';
import {Events} from 'ionic-angular';

import {LoginPage} from '../pages/login/login';
import {HomePage} from '../pages/home/home';

import {Device} from '@ionic-native/device';
import {DashboardHomePage} from "../pages/dashboard-home/dashboard-home";
import {EnquiryPage} from "../pages/enquiry/enquiry";
import {AdmissionPage} from "../pages/admission/admission";
import {AppVersion} from '@ionic-native/app-version';
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {NonenquirylogPage} from "../pages/nonenquirylog/nonenquirylog";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {WhtspPage} from "../pages/whtsp/whtsp";
import {ErpAdmissionPage} from "../pages/erp-admission/erp-admission";
import {GuestPage} from "../pages/guest/guest";
import {ContactPage} from "../pages/contact/contact";
import {DataProgressPage} from "../pages/data-progress/data-progress";
import {DailyLogsPage} from "../pages/daily-logs/daily-logs";
import {CallEnquiryReminderPage} from "../pages/call-enquiry-reminder/call-enquiry-reminder";
import {DataProcessModulePage} from "../pages/data-process-module/data-process-module";
import {CommunicationPage} from "../pages/communication/communication";
import {PreviousSchoolsPage} from "../pages/previous-schools/previous-schools";
import {ArchivedDataTestingDataPage} from "../pages/archived-data-testing-data/archived-data-testing-data";
import {ArchivedDataRegardingJobPage} from "../pages/archived-data-regarding-job/archived-data-regarding-job";
import {StudentActivePage} from "../pages/student-active/student-active";
import {SyncGoogleContactPage} from "../pages/sync-google-contact/sync-google-contact";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LoginPage;
  SchoolName: any;
  SchoolData = {};
  TypeData = {};
  FUserId: any;
  firebasePlugin;


  PlatformName: any;
  alert_popup = null;
  alert_array = [];
  alert_internet_popup = null;
  alert_internet_array = [];
  appversioncode: any;

  constructor(public platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public service: ServiceProvider,
              public storage: Storage,
              private device: Device,
              public _app: App,
              public menuCtrl: MenuController,
              public toastCtrl: ToastController,
              public event: Events,
              private appVersion: AppVersion,
              public iab: InAppBrowser,
              public androidPermissions: AndroidPermissions,
              private alertCtrl: AlertController) {
    this.platform.resume.subscribe(async () => {
      this.check_app_up_to_date();
    });
    platform.ready().then(() => {

      this.check_app_up_to_date();

      if (this.platform.is('android') || this.platform.is('ios') || this.device.platform == 'Android' || this.device.platform == 'iOS') {
        this.firebasePlugin = (<any>window).FirebasePlugin;
        this.firebasePlugin.onMessageReceived(this.onMessageReceived.bind(this));
      }

      this.service.baseUrl = 'http://wwgsadmin.awtech.top/';
       // this.service.baseUrl = 'http://192.168.0.111/wwgsadmin/';

      statusBar.styleLightContent();
      splashScreen.hide();

      this.service.pages = [
        {title: 'Home', component: DashboardHomePage},
        {title: 'Non Enquiry Logs', component: NonenquirylogPage},
        {title: 'Previous Schools', component: PreviousSchoolsPage},
        {title: 'Testing Data', component: ArchivedDataTestingDataPage},
        {title: 'Regarding Job Data', component: ArchivedDataRegardingJobPage},
        {title: 'Student Active', component: StudentActivePage},
        {title: 'Sync Google Contact', component: SyncGoogleContactPage},
        {title: 'Log Out', component: null}
      ];

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.TypeData = {
        "All": 0,
        "Enquiry": 1,
        "Admission": 2,
        "Account": 3,
        "Feedback": 4
      };

      event.subscribe('get_nav', (FUserTypeId) => {
        console.log(JSON.stringify(FUserTypeId));
        this.get_nav(FUserTypeId['FUserTypeId']);
      });

      event.subscribe('app_tabs_rights_by_user_id', (FUserId) => {
        console.log(JSON.stringify(FUserId));
        this.app_tabs_rights_by_user_id(FUserId['FUserId']);
      });

      Promise.all([this.storage.get('LoginData'), this.storage.get('UserName')]).then(values => {
        if (values[0] != "" && values[0] != "null" && values[0] != null) {
          this.menuCtrl.enable(true);
          //this._app.getRootNav().setRoot(TabsPage);
          this._app.getRootNav().setRoot(DashboardHomePage);
          this.FUserId = values[0]['FUserId'];
          this.service.UserName = values[1];
          console.log(this.service.UserName);
          this.service.httpcall('web_service/get_user_is_active?FUserId=' + this.FUserId).subscribe((data: any[]) => {
            if (data['response'] == "error") {
              let alert = this.alertCtrl.create({
                title: 'Error',
                message: data['error_description'],
                buttons: ['Ok']
              });
              alert.present();
              this.logout();
            }
          });
          this.app_tabs_rights_by_user_id(this.FUserId);
        } else {
          this.storage.set('LoginData', "");
          this._app.getRootNav().setRoot(LoginPage);
        }
      });


      //backbutton
      var lastTimeBackPress = 0;
      var timePeriodToExit = 2000;
      platform.registerBackButtonAction(() => {

        let nav = _app.getActiveNavs()[0];
        let activeView = nav ? nav.getActive().instance : null;
        console.log(activeView);


        let nav1 = _app.getActiveNavs()[0];
        let activeView1 = nav1.getActive();
        console.log(activeView1.name);
        console.log(activeView1);

        console.log(nav.canGoBack());

        if ((activeView1 && activeView1.isOverlay) || nav.canGoBack()) {
          nav.pop();
        } else if (activeView instanceof LoginPage ||
          activeView instanceof DataProgressPage ||
          activeView instanceof CallEnquiryReminderPage ||
          activeView instanceof DataProcessModulePage ||
          activeView instanceof HomePage ||
          activeView instanceof DailyLogsPage ||
          activeView instanceof CommunicationPage) {
          if (new Date().getTime() - lastTimeBackPress < timePeriodToExit) {
            platform.exitApp(); //Exit from app
          } else {
            let toast = this.toastCtrl.create({
              message: 'Press back again to exit App?',
              duration: 3000,
              position: 'bottom'
            });
            toast.present();
            lastTimeBackPress = new Date().getTime();
          }
        }
      });


      //firebasetoken
      if (this.platform.is('android') || this.device.platform == 'Android') {
        this.firebasePlugin.getToken(token => {
          this.service.token = token;
          console.log("Token....", token);
          if (token == null || token == 'null' || token == '') {
            this.firebasePlugin.onTokenRefresh(token => {
              console.log("TokenRefresh....", token);
              this.service.token = token;
            }, error => console.error('Error getting Token Refresh', error));
          }
        }, error => console.error('Error getting token', error));
      }
      if (this.platform.is('ios') || this.device.platform == 'iOS') {
        this.firebasePlugin.getToken(token => {
          this.service.token = token;
          console.log("Token....", token);
          if (token == null || token == 'null' || token == '') {
            this.firebasePlugin.onTokenRefresh(token => {
              console.log("TokenRefresh....", token);
              this.service.token = token;
            }, error => console.error('Error getting Token Refresh', error));
          }
        }, error => console.error('Error getting token', error));
        this.firebasePlugin.grantPermission();
      }

      this.checkPermission();

    });

  }

  checkPermission() {
    console.log("Check Permission");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(result => {
        //this.hasPermission = result.hasPermission;
        console.log('Has permission?', result['hasPermission']);
        if (result['hasPermission']) {
          console.log("Has Permission");
        } else {
          console.log("Deny Permission");
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
            console.log(result_data);
            if (result_data['hasPermission']) {
              console.log('Storage allow ', result_data['hasPermission']);
            } else {
              console.log('Storage deny ', result_data['hasPermission']);
            }
          }).catch((err) => {
            console.log("catch loop", JSON.stringify(err));
          });
        }
      },
      err => {
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
          console.log(result_data);
          console.log('error Has permission?', result_data['hasPermission']);
          if (result_data['hasPermission']) {
            console.log('err Storage allow ', result_data['hasPermission']);
          } else {
            console.log('err Storage deny ', result_data['hasPermission']);
          }
        }).catch((err) => {
          console.log(JSON.stringify(err));
        });
      });

  }

  onMessageReceived(message) {
    if (message['tap']) {
      console.log(`Notification was tapped in the ${message['tap']}`);
      console.log("Received in background");
      /*let toast = this.toastCtrl.create({
       position: 'middle',
       message: message['title'],
       duration: 5000,
       showCloseButton: true
       });
       toast.present();*/
    } else {
      console.log("Received in foreground");
      /*let toast = this.toastCtrl.create({
       position: 'middle',
       message: message['title'],
       duration: 5000,
       showCloseButton: true
       });
       toast.present();*/
    }
  }

  app_tabs_rights_by_user_id(FUserId) {
    this.service.TabsRights = {
      Enquiry: false,
      Admission: false,
      Account: false,
      Feedback: false,
      Trackwave: false,
      SuperTrackwave: false,
      Guidelines: false,
      BookCheck: false,
      Doubt: false,
      ClassworkHomework: false
    };
    this.service.httpcall('web_service/app_tabs_rights_by_user_id?FUserId=' + FUserId).subscribe(data => {
      console.log('Rights', data);
      this.service.TabsRights = data;
    })
  }

  check_app_up_to_date() {
    /*this.appVersion.getAppName().then(getAppName => {
     console.log(getAppName);
     });

     this.appVersion.getPackageName().then(getPackageName => {
     console.log("getPackageName "+getPackageName);
     });

     this.appVersion.getVersionCode().then(getVersionCode => {
     console.log("getVersionCode "+getVersionCode);
     });*/
    if (this.platform.is('android') || this.device.platform == 'Android') {
      this.PlatformName = 'ANDROID';
    }
    if (this.platform.is('ios') || this.device.platform == 'iOS') {
      this.PlatformName = 'iOS';
    }
    this.appVersion.getVersionNumber().then(getVersionNumber => {
      console.log("getVersionNumber " + getVersionNumber);
      this.service.appversioncode = "V" + getVersionNumber;
      console.log("Version", this.service.appversioncode);

      this.service.httpcall('web_service/get_app_details?params[PlatformName]=' + this.PlatformName).subscribe((app_details: any[]) => {
        console.log(app_details);
        console.log(getVersionNumber + " " + app_details[0]['VersionNumber']);
        var VersionNumber = getVersionNumber.split('.').join("");
        var UpdatedVersionNumber = app_details[0]['VersionNumber'].split('.').join("");
        if (Number(VersionNumber) < Number(UpdatedVersionNumber)) {
          this.alert_popup = this.alertCtrl.create({
            title: 'Update Available',
            message: 'Download the latest version',
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  console.log('Updated successfully');
                  //  window.location.href = app_details[0]['AppLink'];
                  const browser = this.iab.create(app_details[0]['AppLink'], '_system', {location: 'no'});
                }
              }
            ],
            enableBackdropDismiss: false
          });

          //for prevent multiple alert's
          this.alert_array.push(this.alert_popup);
          if (this.alert_array.length == 1) {
            this.alert_popup.present();
          }

          this.alert_popup.onDidDismiss((data) => {
            this.alert_popup = null;
            this.alert_array = [];
            console.log('Yes/No', data);
          });

        } else {
          console.log("Version Up To Date");
        }

      });
    }).catch((e) => {
      console.log(e);
    });
  }

  get_nav(FUserTypeId) {
    if (FUserTypeId == 3) {
      this.service.pages = [
        {title: 'Home', component: DashboardHomePage},
        {title: 'Non Enquiry Logs', component: NonenquirylogPage},
        {title: 'Previous Schools', component: PreviousSchoolsPage},
        {title: 'Testing Data', component: ArchivedDataTestingDataPage},
        {title: 'Regarding Job Data', component: ArchivedDataRegardingJobPage},
        {title: 'Student Active', component: StudentActivePage},
        {title: 'Log Out', component: null}
      ];
    } else if (FUserTypeId == 4) {
      this.service.pages = [
        {title: 'Home', component: DashboardHomePage},
        {title: 'Non Enquiry Logs', component: NonenquirylogPage},
        {title: 'Previous Schools', component: PreviousSchoolsPage},
        {title: 'Testing Data', component: ArchivedDataTestingDataPage},
        {title: 'Regarding Job Data', component: ArchivedDataRegardingJobPage},
        {title: 'Student Active', component: StudentActivePage},
        {title: 'Log Out', component: null}
      ];
    }
  }

  logout() {
    this.storage.set('UserData', "");
    this.storage.set("LoginData", "");
    this.storage.set("FUserId", "");
    this.storage.set("UserName", "");
    this._app.getRootNav().setRoot(LoginPage);
  }

  openPage(page) {

    // close the menu when clicking a link from the menu
    this.menuCtrl.close();
    // navigate to the new page if it is not the current page
    //this.nav.setRoot(page.component);
    if (page.component) {
      this.nav.setRoot(page.component);
    } else {
      // Since the component is null, this is the logout option
      // ...
      // logout logic
      this.logout();
      // ...
      // redirect to home
      //this.nav.setRoot(HomePage);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts